/**
 * List Schema of OcorrenciaTrackingResponsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {TipoVeiculo} from '@/model/resource/TipoVeiculo'

/* TODO: review generated schema */
export class ListTipoVeiculoSchema extends Schema {
  readonly name = 'ListTipoVeiculo'

  readonly fieldSet: FieldSet<TipoVeiculo> = {
    idTipoVeiculo: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model?.nome || '',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
